'use client'

import type { ReactNode } from 'react'

import { MotionPreset } from '@/components/ui/motion-preset'

/** Нэг мөрөнд орох элемент — зэрэгцээ картуудын хоцролт үүнээс тооцогдоно */
const DEFAULT_COLUMNS = 3

/** Хөрш картуудын хоорондох хоцролт (сек) */
const STAGGER = 0.08

/**
 * Сайтын НЭГДСЭН гарц — «Бусад брэнд» хэсэгт таалагдсан хөдөлгөөн.
 *
 * Элемент дэлгэцэнд орж ирэхэд бүдгэрснээс тодорч, доороос нь дээшээ 40px
 * мандан гарна. Мөр доторх картууд ээлжлэн гарахын тулд индексээр нь бага
 * зэрэг хоцроодог — бүгд зэрэг үсэрвэл нүд аягүй.
 *
 * ⚠️ Хөдөлгөөн НЭГ л удаа тоглоно (`MotionPreset`-ийн `inViewOnce`),
 * тиймээс дээш доош гүйлгэх бүрд дахин анивчихгүй.
 */
export const Reveal = ({
  children,
  index = 0,
  columns = DEFAULT_COLUMNS,
  className
}: {
  children: ReactNode
  index?: number
  columns?: number
  className?: string
}) => (
  <MotionPreset
    fade
    blur
    slide={{ direction: 'down', offset: 40 }}
    delay={(index % columns) * STAGGER}
    transition={{ duration: 0.5 }}
    className={className}
  >
    {children}
  </MotionPreset>
)

/**
 * Бүтэн блокийн гарц — доторх элементүүд нь өөрсдийн гарцгүй үед.
 *
 * Картынхаас намуухан: том блок 40px үсэрвэл хуудас доргих шиг харагдана.
 */
export const RevealSection = ({ children, className }: { children: ReactNode; className?: string }) => (
  <MotionPreset
    fade
    blur
    slide={{ direction: 'down', offset: 24 }}
    transition={{ duration: 0.6 }}
    className={className}
  >
    {children}
  </MotionPreset>
)
